import React from 'react';
import { connect } from 'react-redux';
import I18n from '../../config/locales';
import { isEmpty } from 'lodash';

import { setMobileView, setEnlightenManagerToken, setCountryCode, setFeatureList } from './actions';
import getMoment from '../../components/moment';

class LibraryLayout extends React.Component {
	UNSAFE_componentWillMount() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	}

	handleWindowSizeChange = () => {
		const isMobileView = window.innerWidth <= 1200;
		this.props.setMobileView(isMobileView);
	};

	componentDidMount = () => {
		this.handleWindowSizeChange();
		if (this.props.enlightenManagerToken) {
			this.props.setEnlightenManagerToken(this.props.enlightenManagerToken);
		}
		if (!isEmpty(this.props.featureList)) {
			this.props.setFeatureList(this.props.featureList);
		}
	};

	componentDidUpdate(prevProps) {
		if (this.props.countryCode && this.props.countryCode !== prevProps.countryCode) {
			this.props.setCountryCode(this.props.countryCode);
		}
		if (isEmpty(prevProps.featureList) && !isEmpty(this.props.featureList)) {
			this.props.setFeatureList(this.props.featureList);
		}
		I18n.defaultLocale = 'en';
		if (this.props.locale) {
			I18n.locale = this.props.locale;
			I18n.fallbacks = true;
			getMoment(this.props.locale);
		}
	}

	render() {
		const { component: Component, enlightenManagerToken, featureList, ...remainingProps } = this.props;
		return <Component {...remainingProps} />;
	}
}

const mapDispatchToProps = dispatch => ({
	setMobileView: isMobileView => dispatch(setMobileView(isMobileView)),
	setEnlightenManagerToken: tokenVal => dispatch(setEnlightenManagerToken(tokenVal)),
	setCountryCode: payload => dispatch(setCountryCode(payload)),
	setFeatureList: payload => dispatch(setFeatureList(payload))
});

const mapStateToProps = state => ({
	isMobileView: state.defaultReducer.isMobileView,
	enlightenManagerToken: state.defaultReducer.enlightenManagerToken
});

export default connect(mapStateToProps, mapDispatchToProps)(LibraryLayout);
